import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { ReceiptPrintService } from 'src/app/global/services/receipt-print.service';
import { AppSelectors } from 'src/app/global/state';
import { CscClient, CscStyles, Receipt } from 'src/app/global/state/models/models';
import { PtSelectors } from '../parking-tickets-unauthenticated/state';

@Component({
  selector: 'app-receipts-unauthenticated',
  templateUrl: './receipts-unauthenticated.component.html',
  styleUrls: ['./receipts-unauthenticated.component.scss']
})
export class ReceiptsUnauthenticatedComponent implements OnInit, OnDestroy {

  receipts$: Observable<Receipt[]>;
  styles$: Observable<CscStyles>;
  selectedReceipt$: Observable<Receipt>;
  city: CscClient;
  subscriptions: Subscription[] = [];
  logoImageUrl: Observable<string>;
  receipt: Receipt;
  receipt$: Observable<Receipt>;
  cityInfo$: Observable<CscClient>;

  constructor(
    private store: Store,
    private receiptPdfService: ReceiptPrintService,
    private storage: AngularFireStorage,
  ) 
  { 
    this.styles$ = this.store.select(AppSelectors.getStyles);
    const citySubscription = this.store.select(AppSelectors.getCityContext).subscribe(city => this.city = city);
    this.subscriptions.push(citySubscription);
    this.cityInfo$ = this.store.select(AppSelectors.getCityContext);
    this.selectedReceipt$ = this.store.select(PtSelectors.getReceipt);
    const receiptSubscription = this.selectedReceipt$.subscribe(receipt => this.receipt = receipt);
    this.subscriptions.push(receiptSubscription);
    const subscription1 = this.store.select(AppSelectors.getLogoRef)
    .subscribe(ref => {
      ref ? this.logoImageUrl = this.storage.ref(ref).getDownloadURL() : {};
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onCreateReceiptPdf(): void {

    const subscriptionLogo = this.store.select(AppSelectors.getLogoRef)
      .subscribe(ref => {

        let logoPath = ref.split("/");

        //let logoUrl = "https://storage.googleapis.com/amiga-reporting-images/" + this.city.clientCode + "/" + logoPath[1];
        let logoUrl = "https://storage.googleapis.com/amiga-reporting-images/" + this.city.clientCode + "/" + logoPath[1];

        console.log("logoUrl",logoUrl);

        const subscriptionStyle = this.styles$.subscribe(style => {
          if (style) {
            //pass the logo url as string and style object to receipt pdf service
            console.log("")
            this.receiptPdfService.createReceiptPdf(this.receipt, logoUrl, style);
          }
        }
        )
        this.subscriptions.push(subscriptionStyle);
      })
    this.subscriptions.push(subscriptionLogo);
  }

}
